import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "align", "id", "style", "children", "as", "isAnimated"];
import React from 'react';
import { motion } from 'framer-motion';
import { responsivePropType, appendResponsiveHtmlClass } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var Element = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    align = props.align,
    id = props.id,
    style = props.style,
    children = props.children,
    as = props.as,
    isAnimated = props.isAnimated,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var ALIGNMENT_PREFIX = getConfig('TEXT_ALIGNMENT_PREFIX');
  var HtmlElement = isAnimated ? motion[props['as']] : props['as'];
  var cls = align ? appendResponsiveHtmlClass(className, align, ALIGNMENT_PREFIX) : className;
  return /*#__PURE__*/React.createElement(HtmlElement, Object.assign({
    ref: ref,
    className: cls,
    id: id,
    style: style
  }, other), children);
});
Element.defaultProps = {
  as: 'div',
  style: {},
  isAnimated: false
};
export default Element;